/**
 * AP Invoices Demo — MRO Supply Co. invoice history for the "show me the last
 * invoices from this supplier" chat scenario.
 *
 * THROWAWAY DEMO CODE. A static, read-only set of recent invoices from the hero
 * supplier (MRO Supply Co.). The current invoice (AIG-90412) sits at the top and
 * is well above the recent run rate, so the trend chart tells a story. Dates are
 * relative to "today" so the data never goes stale. Backs
 * `SupplierInvoiceHistoryDialog`. Delete with src/demo/ap.
 */

import { AP_DEMO_IDS } from '../fixture-seed';

export const SUPPLIER_HISTORY_NAME = 'MRO Supply Co.';
export const SUPPLIER_HISTORY_CURRENCY = 'USD';

export interface SupplierInvoiceHistoryItem {
  id: string;
  invoiceNumber: string;
  /** YYYY-MM-DD. */
  invoiceDate: string;
  subtotal: number;
  taxAmount: number;
  totalAmount: number;
  /** True for the invoice currently open in the detail panel. */
  isCurrent: boolean;
}

function daysAgo(days: number): string {
  const d = new Date();
  d.setHours(12, 0, 0, 0);
  d.setDate(d.getDate() - days);
  return d.toISOString().slice(0, 10);
}

/**
 * Most-recent first. The current invoice (AIG-90412, $9,800) is ~46% above the
 * prior five-invoice average (~$6,690), so the trend line ends on a clear spike.
 */
export const SUPPLIER_INVOICE_HISTORY: SupplierInvoiceHistoryItem[] = [
  {
    id: AP_DEMO_IDS.invoiceAtl,
    invoiceNumber: 'AIG-90412',
    invoiceDate: daysAgo(4),
    subtotal: 9800,
    taxAmount: 0,
    totalAmount: 9800,
    isCurrent: true,
  },
  {
    id: 'aig-89740',
    invoiceNumber: 'AIG-89740',
    invoiceDate: daysAgo(34),
    subtotal: 6800,
    taxAmount: 0,
    totalAmount: 6800,
    isCurrent: false,
  },
  {
    id: 'aig-89102',
    invoiceNumber: 'AIG-89102',
    invoiceDate: daysAgo(63),
    subtotal: 7250,
    taxAmount: 0,
    totalAmount: 7250,
    isCurrent: false,
  },
  {
    id: 'aig-88431',
    invoiceNumber: 'AIG-88431',
    invoiceDate: daysAgo(94),
    subtotal: 6420,
    taxAmount: 0,
    totalAmount: 6420,
    isCurrent: false,
  },
  {
    id: 'aig-87766',
    invoiceNumber: 'AIG-87766',
    invoiceDate: daysAgo(124),
    subtotal: 7010,
    taxAmount: 0,
    totalAmount: 7010,
    isCurrent: false,
  },
  {
    id: 'aig-87012',
    invoiceNumber: 'AIG-87012',
    invoiceDate: daysAgo(155),
    subtotal: 5980,
    taxAmount: 0,
    totalAmount: 5980,
    isCurrent: false,
  },
];

/** The N most-recent invoices, most-recent first (defaults to the whole set). */
export function recentSupplierInvoices(
  n = SUPPLIER_INVOICE_HISTORY.length,
): SupplierInvoiceHistoryItem[] {
  return SUPPLIER_INVOICE_HISTORY.slice(0, Math.max(1, n));
}
